import { IConfig } from '@cian/config/shared';
import { TAllOfferChatOnboardings } from 'shared/types/chatOnboarding';

import { getOfferChatOnboarding } from './internal/getOfferChatOnboarding';
import { TOfferDataParam } from './types';

interface IParams {
  config: IConfig;
  data: TOfferDataParam;
}

export function getAllOfferChatOnboardings({ config, data }: IParams): TAllOfferChatOnboardings {
  const page = data.jsonQuery?.page?.value;

  if (page && page > 1) {
    return {
      offerChatOnboarding: null,
    };
  }

  return {
    offerChatOnboarding: getOfferChatOnboarding({ config, data }),
  };
}
